import Http from '@/api/index.js'

class Performance extends Http {
    constructor() {
        super()
    }

    //绩效列表
    searchReport(params) {
        return this.post('/report/searchReport',params)
    }
    //删除绩效
    delReport(params) {
        return this.post('/report/delReport', params)
    }
    //发布绩效
    publishReport(params) {
        return this.post('/report/publishReport', params)
    }
    //导出文件
    export(id) {
        return this.downLoad(`/report/export/${id}`)
    }

    static get getEntityType() {
        return 5
    }

    static get getAdminEntityType() {
        return 4
    }
   
}

export default Performance